import { Typography } from '@material-ui/core'
import { LocalizedWorkingStepLabel } from 'components/Localization/LocalizedWorkingStepLabel'
import { MoneyString } from 'model/Money'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'

export const WorkingStepTooltip = (props: { data: TargetPriceGraphData }) => {
  const { t } = useTranslation()

  return (
    <div>
      <Typography>
        <LocalizedWorkingStepLabel
          workingStepType={props.data.primaryWorkingStep as WorkingStepType}
        />
      </Typography>
      {props.data.sharedCost && (
        <Typography variant="caption">(shared cost)</Typography>
      )}
      {Object.keys(props.data)
        .filter(
          (key) =>
            key !== 'id' &&
            key !== 'description' &&
            key !== 'sharedCost' &&
            key !== 'matchDescription'
        )
        .map((d, index) => (
          <TargetPriceTooltipListItemText
            key={`${props.data.description}-${d}-${index}`}
            primary={props.data[d]['value'] ? MoneyString(props.data[d]) : '-'}
            secondary={t(`project:${d}`, d)}
          />
        ))}
    </div>
  )
}
